$(function () {
    var list = $('.hindle-shop-widget.-cart .items');
    var items = $('.hindle-shop-widget.-cart .item');

    if (items.length === 0) {
        return;
    }

    items.each(function (index, element) {
        var item = $(element);
        var side = item.find('.side');
        var link = item.find('.remove');

        // Make sure that each item in the cart has a "remove item" link
        if (side.length === 0) {
            side = $('<div class="side"></div>');
            item.find('.wrap').prepend(side);
        }

        if (link.length === 0) {
            link = $('<a href="#" class="remove"><span class="screen-reader-text">Remove</span></a>');
            side.append(link);
        }

        // Perform an AJAX request on click
        link.on('click', function (e) {
            var url = item.data('url');
            var data = {
                action: 'hindle_widget_remove_product', // WP action to run
                key: item.data('key') // key of product to be removed
            };

            e.preventDefault();
            $.post(url, data, function (response) {
                var label = response.count === 1 ? ' item' : ' item';

                // Fade the item out, then remove it completely
                item.fadeOut().promise().done(function () {
                    item.remove();

                    // Update the cart count and total where ever they appear on
                    // the page.
                    $('.hindle-shop-count').text(response.count + label);
                    $('.hindle-shop-total').text(response.total);

                    // If the cart is now empty, show a message instead of an
                    // empty list. This will only apply when removing the last
                    // item via AJAX; the cart widget does not normally appear
                    // if there are no items in the cart.
                    if (response.count === 0) {
                        var message = list.prev('.message');

                        if (message.length === 0) {
                            message = $('<p class="message"><em>No products in cart</em></p>');
                            list.before(message);
                        }

                        list.hide();
                        message.show();
                    }
                });

            }, 'json');
        });
    });
});
